import { compact, first } from "lodash";
export var ADDRESS_VALIDATION = {
  UNVALIDATED: "UNVALIDATED",
  PARTIALLY_CITY: "PARTIALLY_CITY",
  PARTIALLY_STATE: "PARTIALLY_STATE",
  PARTIALLY_STREET: "PARTIALLY_STREET",
  VALIDATED: "VALIDATED",
  CUSTOM_CONFIRMED: "CUSTOM_CONFIRMED"
};
export var singleLineAddress = function singleLineAddress(_ref) {
  var _ref$streetNumber = _ref.streetNumber,
      streetNumber = _ref$streetNumber === void 0 ? "" : _ref$streetNumber,
      _ref$route = _ref.route,
      route = _ref$route === void 0 ? "" : _ref$route,
      _ref$subpremise = _ref.subpremise,
      subpremise = _ref$subpremise === void 0 ? "" : _ref$subpremise,
      _ref$city = _ref.city,
      city = _ref$city === void 0 ? "" : _ref$city,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? "" : _ref$state,
      _ref$postalCode = _ref.postalCode,
      postalCode = _ref$postalCode === void 0 ? "" : _ref$postalCode;
  return compact([compact([streetNumber.trim(), route.trim(), subpremise]).join(" "), city, compact([state, postalCode]).join(" "), "USA"]).join(", ");
};

var getValidationStatus = function getValidationStatus(_ref2) {
  var location_type = _ref2.geometry.location_type,
      types = _ref2.types;

  if (location_type === "ROOFTOP" || types.includes("premise") || types.includes("subpremise") || types.includes("street_address") || types.includes("establishment")) {
    return ADDRESS_VALIDATION.VALIDATED;
  } else if (types.includes("route")) {
    return ADDRESS_VALIDATION.PARTIALLY_STREET;
  } else if (types.includes("locality")) {
    return ADDRESS_VALIDATION.PARTIALLY_CITY;
  } else if (types.includes("administrative_area_level_1")) {
    return ADDRESS_VALIDATION.PARTIALLY_STATE;
  } else {
    return ADDRESS_VALIDATION.UNVALIDATED;
  }
}; // Return a function that can find the geocode address component by name
// That function returns the long name and short name in an array


export var geocodeAddressComponents = function geocodeAddressComponents(components) {
  var lookupByName = components.reduce(function (acc, _ref3) {
    var long_name = _ref3.long_name,
        short_name = _ref3.short_name,
        types = _ref3.types;
    return types.reduce(function (acc2, type) {
      if (!acc2[type]) {
        acc2[type] = [long_name, short_name];
      }

      return acc2;
    }, acc);
  }, {});
  return function (name) {
    return lookupByName[name] || ["", ""];
  };
};

var chooseCity = function chooseCity(display) {
  for (var _len = arguments.length, possibleValues = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    possibleValues[_key - 1] = arguments[_key];
  }

  var values = compact(possibleValues).filter(function (value) {
    return isNaN(parseInt(value));
  });
  return values.find(function (value) {
    return display.toLowerCase().includes(value.toLowerCase());
  }) || first(values);
};

export var mapGeocodeToAddress = function mapGeocodeToAddress(_ref4) {
  var components = _ref4.address_components,
      display = _ref4.formatted_address,
      geometry = _ref4.geometry,
      _ref4$types = _ref4.types,
      types = _ref4$types === void 0 ? [] : _ref4$types,
      name = _ref4.name,
      place_id = _ref4.place_id;
  var getValue = geocodeAddressComponents(components);
  return {
    display: display,
    placeId: place_id,
    state: getValue("administrative_area_level_1")[1],
    streetNumber: getValue("street_number")[0],
    route: getValue("route")[1],
    subpremise: getValue("subpremise")[0],
    city: chooseCity.apply(void 0, [display].concat(getValue("locality"), getValue("administrative_area_level_3"), getValue("sublocality"), getValue("neighborhood"), getValue("sublocality_level_1"))),
    county: getValue("administrative_area_level_2")[0],
    postalCode: getValue("postal_code")[0],
    postalCodeSuffix: getValue("postal_code_suffix")[0],
    locationType: geometry.location_type,
    lat: geometry.location.lat(),
    lng: geometry.location.lng(),
    placeName: types.includes("establishment") ? name : undefined,
    validation: getValidationStatus({
      geometry: geometry,
      types: types
    })
  };
};